import React, { useCallback } from 'react'
import { Container, Panel } from '@sencha/ext-modern'
import { connect } from 'react-redux'

import Form from '../public/components/Form'
import FormMessage from '../public/components/FormMessage'
  
import MyTasks from '../public/components/MyTasks' 
import { useInstData } from '../public/hooks'

const Dashboard = props => {
	const {
		me, setState,
		me: { state: {
			reloadStamp, showDetail: Detail, // quarterlyData, monthlyData
		} }
	} = useInstData(props, useCallback(() => ({
		showDetail: component => { setState({ showDetail: component }) },
		refreshPage: () => { setState({ reloadStamp: Date.now() }) }
	}), []))

	const closeDetail = () => {
		setState({ showDetail: null, reloadStamp: Date.now() })
	}

	// const getDashBoardData = () => {
	// }

	// useEffect(() => {
	//   getDashBoardData()
	//   return () => me.unmounted = true
	// }, [])

	// refreshPage = () => {
	//   doGetDashBoardData()
	// }

	// console.log(tasks)
	return <React.Fragment >
		{Detail && <Detail showBody={Form} showMessage={FormMessage} onClose={closeDetail} />}
		< Container hidden={Detail} width={!Ext.os.is.Phone && 700} layout={{ type: 'vbox', pack: 'center', align: 'stretch' }}    >
			<Container autoSize defaults={{ flex: 1, shadow: true }} flex={2}
				layout={{ type: Ext.os.is.Phone ? 'vbox' : 'hbox', pack: 'center', align: 'stretch' }}
			>
				<Panel title="我的任务看板" ui="light" layout="fit" margin='6 10 6 10'>
					<MyTasks reloadStamp={reloadStamp} that={me} /* maxFetch={10} */ />
				</Panel>
			</Container>
			{/* <Container
          autoSize
          defaults={{ flex: 1, shadow: true }}
          layout={{ type: Ext.os.is.Phone ? 'vbox' : 'hbox', pack: 'center', align: 'stretch' }}
          flex={3}
        >
          <Application monthlyData={monthlyData} />
          <QuarterlyBar quarterlyData={quarterlyData} />
        </Container> */}
		</Container >
	</React.Fragment >
}

export default Dashboard
// const mapStateToProps = ({ loginInfo: { menu } }) => {
//   return { menu }
// }
// export default connect(mapStateToProps, null)(Dashboard)
